// ceremony Reducer
const ceremonyDefaultState = {
    // ceremony: '',
    // religiousDenomination: '',
    // ceremonyPlace: '',
    // town: '',
    // country: '',
    // zipCode: '',
    // inhumation: '',
    // dispersion: "0",
    // wayOfDispersion: '',
    // dispersionPlace: '',
    // ashesDelivery: '',
    // cemeteryName: '',
    // cemeteryZipCode: '',
    // cemeteryTown: '',
    // cemeteryCountry: '',
    // inhumationPlace: '',
    // concession: "0",
    // vault: "0",
    // files : []
    obj : {}
};

export default (state = ceremonyDefaultState, action) => {
    switch (action.type) {
        case 'SET_CEREMONY':
            return {
                ...state,
                obj: action.data,
                // religiousDenomination: action.data.religiousDenomination,
                // ceremonyPlace: action.data.ceremonyPlace,
                // town: action.data.town,
                // country: action.data.country,
                // zipCode: action.data.zipCode,
                // inhumation: action.data.inhumation,
                // dispersion: action.data.dispersion,
                // wayOfDispersion: action.data.wayOfDispersion,
                // dispersionPlace: action.data.dispersionPlace,
                // ashesDelivery: action.data.ashesDelivery,
                // cemeteryName: action.data.cemeteryName,
                // cemeteryZipCode: action.data.cemeteryZipCode,
                // cemeteryTown: action.data.cemeteryTown,
                // cemeteryCountry: action.data.cemeteryCountry,
                // inhumationPlace: action.data.inhumationPlace,
                // concession: action.data.concession,
                // vault: action.data.vault,
                // files : action.data.files
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/ceremony.js